<template>
    <div>
        <div v-cloak v-show="loading">
            <div class="category-loader my-3 h-12 placeholder-media w-full sm:w-2/4 md:w-2/4">
                <div class="line my-2"></div>
            </div>
        </div>

        <div v-cloak v-show="!loading">
            <div v-cloak v-show="!emptyCategories">
                <category-item v-for="category in categories" :key="category.id" :category="category" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        categories: [],
        loading: false
    }),

    created() {
        this.fetchCategories();
    },

    mounted() {},

    computed: {
        emptyCategories() {
            return this.categories.length == 0;
        }
    },

    methods: {
        fetchCategories() {
            this.loading = true;

            axios
                .get("/api/categories", {
                    params: {}
                })
                .then(response => {
                    this.categories = response.data;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
// .category-loader {}
</style>
